import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const TrendLineGraph = ({ data }) => {
  // Format data for Recharts
  const chartData = Object.entries(data || {}).map(([date, entries]) => {
    const dataPoint = { name: date };
    (entries || []).forEach((entry) => {
      dataPoint[`cumulativeMWp_${entry.wattage}`] = entry.cumulativeMWp;
    });
    return dataPoint;
  });

  // Get list of unique wattages
  const wattages = [
    ...new Set(
      Object.values(data || {})
        .flat()
        .map((entry) => entry.wattage)
    ),
  ];

  // Define colors for lines (extendable for more wattages)
  const colors = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"];

  return (
    <div style={{ width: "100%", height: 400 }}>
      <h3>Power Generation Trend</h3>
      <ResponsiveContainer>
        <LineChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} />
          <YAxis label={{ value: "Cumulative MWp", angle: -90, position: "insideLeft" }} />
          <Tooltip />
          <Legend />
          {wattages.map((wattage, index) => (
            <Line
              key={wattage}
              type="monotone"
              dataKey={`cumulativeMWp_${wattage}`}
              stroke={colors[index % colors.length]} // Cycle through colors
              dot={{ r: 3 }}
              strokeWidth={2}
              name={`${wattage}W`} // Display wattage in legend
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrendLineGraph;